import script from "./BlankSlate.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlankSlate.vue?vue&type=script&setup=true&lang=ts"

import "./BlankSlate.vue?vue&type=style&index=0&id=57d1beda&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57d1beda"]])

export default __exports__